/* eslint-disable react/jsx-pascal-case */
import react, { useState, ReactFragment, useRef, useEffect } from "react";
import {
  NavCar,
  Description,
  Offers,
  First_Project,
  Second_Project,
  Third_Project,
  Company,
  Let_Talk,
  Navbar,
  About,
  Projects,
  ECommerce,
  Data_Target,
  Attendo,
  ContactPage,
  Loader,
  ScrollArrow,
  Fourth_Project,
  AllProject
} from "./components/index";
import style from "./App.module.css";
import { useSpring, animated } from "react-spring";
import { BrowserRouter as Router, Route } from "react-router-dom";

function App() {


  var production = "https://bennovela.netlify.app";
  var development = "http://localhost:3000"

  useEffect(()=>{
    console.log(window.location.href);

    if(window.location.href !== `${production}/`){
      setHomePageTimer(false);
    }

    if(window.location.href !== `${production}/allProject`){
      setProjPageTimer(false);
    }
  })


  const [state, toggle] = useState(false);
  const [about, setAbout] = useState(false);
  const [allProject, setAllProject] = useState(false);
  const [project, setProject] = useState(false);
  const [project2, setProject2] = useState(false);
  const [data, setData] = useState(false);
  const [attendo, setAttendo] = useState(false);
  const [contact, setContact] = useState(false);

  //Setting up Loader Algorithm
  const [navcarServer, setnavCarServer] = useState(false);
  const [aboutpageServer, setAboutPageServer] = useState(false);
  const [allProjectServer, setAllProjectServer] = useState(false);
  const [eCommerceServer, setEcommerceServer] = useState(false);
  const [dataServer, setDataServer] = useState(false);
  const [projectServer, setProjectServer] = useState(false);
  const [attendoServer, setAttendoServer] = useState(false);
  const [contactServer, setContactServer] = useState(false);
  const [homepageTimer, setHomePageTimer] = useState(false);
  const [projPageTimer, setProjPageTimer] = useState(false);

  /*IMAGE SLIDER ALGORITHM*/
  var projSelct;
  var innerProj;
  const maxH = 3000;
  const minH = 2444;
  const [activateScroll, setActivateScroll] = useState(false);
  const ref = useRef();

  /*useEffect(()=>{ 
    checkScroll();
  },[activateScroll]);

  

  const checkScroll = ()=>{
      projSelct = ref.current.childNodes[2];
      innerProj = projSelct.childNodes[2];
      console.log(innerProj)
  }


  window.addEventListener('scroll',()=>{
    console.log(activateScroll);
    if(window.pageYOffset === 2444){
      setActivateScroll(true);
    }else if(window.pageYOffset >=3000){
      setActivateScroll(false);
    }else if(window.pageYOffset<2444){
      setActivateScroll(false);
    }
  })
  */

  const { x } = useSpring({
    from: { x: 0 },
    x: state ? 1 : 0,
    config: { duration: 1000 },
  });

  return (
    <Router>
      <div className={style.App}>
        <Route
          path="/"
          exact
          render={(props) => (
            <div ref={ref}>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                contact={contact}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setData={setData}
                setAllProject={setAllProject}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <NavCar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                project2={project2}
                navcarServer={navcarServer}
                setnavCarServer={setnavCarServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <div style={{ display: homepageTimer ? "block" : "none" }}>
                <Description navcarServer={navcarServer} />
                <Offers navcarServer={navcarServer} />
                <First_Project
                  activateScroll={activateScroll}
                  setActivateScroll={setActivateScroll}
                  navcarServer={navcarServer}
                  id="firstProj"
                />
                <Second_Project navcarServer={navcarServer} />
                <Third_Project navcarServer={navcarServer} />
                <Fourth_Project navcarServer={navcarServer} />
                <Company navcarServer={navcarServer} />
                <Let_Talk navcarServer={navcarServer} />
              </div>
            </div>
          )}
        />

        <Route
        path="/allProject"
        render={(props)=>(
          <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                contact={contact}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <AllProject
                setAllProjectServer={setAllProjectServer}
                allProjectServer={allProjectServer}
                toggle={toggle}
                setProjPageTimer={setProjPageTimer}
              />
              <div style={{ display: projPageTimer ? "block" : "none" }} >
              <Let_Talk  />
              </div>
            </div>
        )}
        />

        <Route
          path="/about"
          render={(props) => (
            <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                contact={contact}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <About
                setAboutPageServer={setAboutPageServer}
                aboutpageServer={aboutpageServer}
                toggle={toggle}
              />
            </div>
          )}
        />
        <Route
          path="/projects"
          render={(props) => (
            <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                contact={contact}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <Projects
                setProjectServer={setProjectServer}
                projectServer={projectServer}
                toggle={toggle}
              />
            </div>
          )}
        />
        <Route
          path="/project2"
          render={(props) => (
            <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <ECommerce
                setEcommerceServer={setEcommerceServer}
                eCommerceServer={eCommerceServer}
                toggle={toggle}
              />
            </div>
          )}
        />

        <Route
          path="/data"
          render={(props) => (
            <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <Data_Target
                dataServer={dataServer}
                setDataServer={setDataServer}
                toggle={toggle}
              />
            </div>
          )}
        />

        <Route
          path="/attendo"
          render={(props) => (
            <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setContactServer={setContactServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <Attendo
                attendoServer={attendoServer}
                setAttendoServer={setAttendoServer}
                toggle={toggle}
              />
            </div>
          )}
        />

        <Route
          path="/contact"
          render={(props) => (
            <div>
              <Navbar
                x={x}
                toggle={toggle}
                state={state}
                about={about}
                project={project}
                allProject={allProject}
                setAbout={setAbout}
                setProject={setProject}
                setProject2={setProject2}
                setContact={setContact}
                setAllProject={setAllProject}
                setData={setData}
                setAttendo={setAttendo}
                setnavCarServer={setnavCarServer}
                setAboutPageServer={setAboutPageServer}
                setAllProjectServer={setAllProjectServer}
                setEcommerceServer={setEcommerceServer}
                setProjectServer={setProjectServer}
                setContactServer={setContactServer}
                setDataServer={setDataServer}
                setAttendoServer={setAttendoServer}
                setHomePageTimer={setHomePageTimer}
                setProjPageTimer={setProjPageTimer}
              />
              <ContactPage
                setContactServer={setContactServer}
                contactServer={contactServer}
                toggle={toggle}
              />
            </div>
          )}
        />
      </div>
    </Router>
  );
}

export default App;
